<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="HTTPServers"
      :items="HTTPServers"
      :fields="HTTPServersFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedHTTPServer"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      HTTPServersFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'url', label: this.$i18n.t('URL'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'type', label: this.$i18n.t('Method`s type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}

      ],
      methodTypes: {
        0: 'GET',
        1: 'PUT',
        2: 'POST',
        3: 'DELETE',
        4: 'PATCH'
      },
      methodTypesRevert: {
        'GET': 0,
        'PUT': 1,
        'POST': 2,
        'DELETE': 3,
        'PATCH': 4
      },
      selectedHTTPServer: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedHTTPServer = {
        id: 0,
        url: 'http://127.0.0.1/',
        type: 'GET',
        name: 'New HTTP server'
      }
      this.$bvModal.show('modalEditHTTPServer')
    },
    editItem (item) {
      this.selectedHTTPServer = JSON.parse(JSON.stringify(item))
      this.selectedHTTPServer.type = this.methodTypesRevert[this.selectedHTTPServer.type]
      this.$bvModal.show('modalEditHTTPServer')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "HTTP server"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_HTTP_SERVERS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_HTTP_SERVERS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    HTTPServers () {
      let tmp = JSON.parse(JSON.stringify(this.$store.getters['Settings/HTTP_SERVERS']))
      tmp.filter(it => {
        it.type = this.methodTypes[it.type]
        return it
      })
      return tmp
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_HTTP_SERVERS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/httpServers/main.vue